<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'

import { api, messageFrom } from '../api'
import type { Generation } from '../types'

const generations = ref<Generation[]>([])
const error = ref('')
const loading = ref(true)
let timer: number | null = null

function statusTitle(status: Generation['status']): string {
  return {
    queued: 'В очереди', processing: 'Рисуется', completed: 'Готово',
    failed: 'Ошибка', blocked_nsfw: 'Отклонено NSFW',
  }[status]
}

async function load(schedule = false): Promise<void> {
  error.value = ''
  try { generations.value = (await api<{ generations: Generation[] }>('/api/admin/generations')).generations }
  catch (reason) { error.value = messageFrom(reason) }
  finally {
    loading.value = false
    if (schedule) timer = window.setTimeout(() => void load(true), 5_000)
  }
}

onMounted(() => void load(true))
onBeforeUnmount(() => { if (timer !== null) window.clearTimeout(timer) })
</script>

<template>
  <main class="page">
    <div class="page-title">
      <div><p class="eyebrow">Последние 200</p><h2>Генерации</h2></div>
      <button class="button button--quiet" type="button" @click="load(false)">Обновить</button>
    </div>
    <p v-if="error" class="error">{{ error }}</p>
    <p v-if="loading" class="muted">Загружаю ленту…</p>
    <div v-else class="generation-feed">
      <article v-for="item in generations" :key="item.id" class="generation-card">
        <div class="generation-thumb">
          <img v-if="item.status === 'completed'" :src="`/media/generations/${item.id}`" :alt="item.preset_title" />
          <span v-else>{{ statusTitle(item.status) }}</span>
        </div>
        <div class="generation-info">
          <div class="generation-title">
            <strong>{{ item.preset_emoji }} {{ item.preset_title }}</strong>
            <span :class="['status', `status--${item.status}`]">{{ statusTitle(item.status) }}</span>
          </div>
          <p>{{ item.model_title }} · {{ item.source }}</p>
          <p>
            {{ item.cost_usd === null ? 'Цена ещё неизвестна' : `${(Number(item.cost_usd) * 80).toFixed(2)} ₽ · $${Number(item.cost_usd).toFixed(4)}` }}
            <template v-if="item.runtime_ms !== null"> · {{ (item.runtime_ms / 1000).toFixed(1) }} с</template>
          </p>
          <p class="muted">TG: {{ item.telegram_user_id || 'админка' }} · {{ new Date(item.created_at).toLocaleString('ru-RU') }}</p>
          <p v-if="item.error" class="error">{{ item.error }}</p>
        </div>
      </article>
      <p v-if="!generations.length" class="muted">Генераций пока нет.</p>
    </div>
  </main>
</template>
